// Started once at boot and never torn down: a bridge per <Snackbars> instance showed the same toast twice
// when a visit between two layouts remounted it.
import { router } from '@inertiajs/svelte'
import { show, type SnackbarType } from 'shared/javascripts/components/snackbar.svelte'
import type { FlashData, FlashMessages } from 'types/index'

const SNACKBAR_TYPES: Record<keyof FlashMessages, SnackbarType> = {
  notice: 'info',
  success: 'info',
  alert: 'error',
  danger: 'error',
  error: 'error',
}

function showFlash(flash: FlashData): void {
  for (const [key, message] of Object.entries(flash)) {
    const type = SNACKBAR_TYPES[key as keyof FlashMessages]
    if (type && typeof message === 'string') {
      show({ message, type })
    }
  }
}

let unsubscribe: (() => void) | null = null

export function startFlashBridge(): void {
  if (unsubscribe) {
    return
  }

  // Inertia fires `flash` for the initial page too, once its history write is through, which is after
  // the layout has mounted. It skips deferred-prop responses and back/forward, so nothing replays.
  unsubscribe = router.on('flash', (event) => showFlash(event.detail.flash))
}

export function stopFlashBridge(): void {
  unsubscribe?.()
  unsubscribe = null
}
